import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Tabs} from 'antd';
import tQuestionStudyActions from 'Actions/ai/questionStudy';

const {TabPane} = Tabs;

class TabsComponent extends Component {
  onTabChange = value => {
    const {questionStudyActions, getTableList, searchData} = this.props;

    // 设置tab的activeKey
    questionStudyActions.setTabActiveKey(value);
    // 设置查询条件
    questionStudyActions.setSearchData({
      ...searchData,
      status: parseInt(value, 10),
    });
    // 设置pageNum与pageSize
    questionStudyActions.setPageStatus({pageNum: 1, pageSize: 20});
    // 获取table列表数据
    getTableList({
      ...searchData,
      status: parseInt(value, 10),
      pageNum: 1,
      pageSize: 20,
    });
  };

  render() {
    const {tabActiveKey} = this.props;

    return (
      <Tabs
        type="card"
        activeKey={String(tabActiveKey)}
        onChange={this.onTabChange}>
        <TabPane tab="待学习" key="1" />
        <TabPane tab="已学习" key="2" />
        <TabPane tab="已忽略" key="3" />
      </Tabs>
    );
  }
}

const mapStateToProps = ({aiQuestionStudy}) => ({
  tabActiveKey: aiQuestionStudy.tabActiveKey,
  searchData: aiQuestionStudy.searchData,
});

const mapDispatchToProps = dispatch => ({
  questionStudyActions: bindActionCreators(tQuestionStudyActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TabsComponent);
